import * as React from 'react';
import { StyleSheet, View, Text, ActivityIndicator } from 'react-native';
import { font } from '../../style/text';
import color from '../../style/color';
import { getLocalizedTexts } from '../../Locales';

export const TEXT_TRANSITION_DELAY_IN_MS = 3000;

export function useCyclingText(texts: string[]): string {
    const [index, setIndex] = React.useState(0);
    React.useEffect(() => {
        if (texts.length <= 1) return;
        let currentIndex = 0;
        const interval = setInterval(() => {
            currentIndex = Math.min(currentIndex + 1, texts.length - 1);
            setIndex(currentIndex);
        }, TEXT_TRANSITION_DELAY_IN_MS);
        return () => clearInterval(interval);
    }, [texts]);
    return texts[index] ?? texts[0];
}

export function LottieWithText({ text }: { text: string }) {
    return (
        <View style={styles.lottieWithTextContainer}>
            <View style={styles.lottieContainer}>
                <ActivityIndicator size="large" color={color.caribbeanGreen} />
            </View>
            <Text style={styles.lottieText}>{text}</Text>
        </View>
    );
}

export function getPrePaymentTexts(numberOfCards: number): string[] {
    const texts = getLocalizedTexts().giftCardPaymentPage.loadingTexts;
    return [
        numberOfCards > 1 ? texts.checkingGiftCards : texts.checkingGiftCard,
        texts.preparingCart,
        texts.justAFewMoments,
    ];
}

export function getPostPaymentTexts(numberOfCards: number): string[] {
    const texts = getLocalizedTexts().giftCardPaymentPage.loadingTexts;
    return [
        texts.processingPayment,
        numberOfCards > 1 ? texts.creatingCards : texts.creatingCard,
        texts.finalizingPurchase,
    ];
}

const styles = StyleSheet.create({
    lottieWithTextContainer: {
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
        paddingVertical: 60,
    },
    lottieContainer: {
        marginBottom: 20,
    },
    lottieText: {
        fontFamily: font.ambitBold,
        fontSize: 18,
        lineHeight: 26,
        textAlign: 'center',
        color: color.black,
        width: 330,
    },
});
